<template>
  <emd-card
    class="_footer_spaced_sm"
    noBorder
  >
    <emd-card-header>
      <emd-text tag="h2">{{ $t('invite.list.title') }}</emd-text>
      <template #actions>
        <router-link
          :to="{ name: 'invites-create' }"
          class="jsModalOpen"
        >
          <jade-button
            variant="primary-solid"
            size="small"
          >
            {{ $t('invite.list.button-invite') }}
          </jade-button>
        </router-link>
      </template>
    </emd-card-header>

    <invite-alert
      v-if="alert.show"
      :alert="alert"
      @cancel="$emit('resetAlert')"
    />

    <emd-card-content customClass="eu-no-padding">
      <empty-list
        v-if="showEmptyList"
        entity="invites"
      />

      <template v-else>
        <InvitesTable
          :items="items"
          :actions="actions()"
        />

        <pagination
          type="list"
          :action="action"
          :pagination="pagination"
          :totalShowing="totalItems"
        />
      </template>
    </emd-card-content>
  </emd-card>
</template>
<script>
import InvitesTable from '@/views/Team/Invites/components/InvitesTable.vue'
import {
  EmdCard,
  EmdCardHeader,
  EmdCardContent,
  EmdText
} from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import { mapGetters } from 'vuex'
import {
  invitesGetEnabled,
  invitesRemoveEnabled,
  invitesResendEnabled
} from '@/actions-permission/invites.permissions'
import InviteAlert from '@/views/Team/Invites/components/InviteAlert.vue'
import JadeButton from '@/components/jade/JadeButton/index.vue'
export default {
  name: 'InvitesContent',
  components: {
    InviteAlert,
    EmdCard,
    EmdCardHeader,
    EmdCardContent,
    EmdText,
    JadeButton,
    EmptyList,
    Pagination,
    InvitesTable
  },

  props: {
    isLoading: Boolean,
    items: Array,
    pagination: Object,
    alert: Object,
    totalItems: Number,
    action: String
  },

  data () {
    return {
      showAlert: false,
      formError: false,
      errors: [],
      typeAction: null
    }
  },

  computed: {
    ...mapGetters(['permissionIsEnabled']),
    showEmptyList () {
      return this.emptyList()
    }
  },

  methods: {
    actions () {
      return [
        {
          type: 'function',
          field: 'showResendButton',
          hasPermission: invitesResendEnabled(this.permissionIsEnabled),
          title: this.$t('invite.resend-invite'),
          icon: 'redo',
          fnAction: invite => this.$emit('openModal', invite, 'RESEND_INVITE')
        },
        {
          type: 'function',
          field: 'showRemoveButton',
          showButton: true,
          title: this.$t('invite.delete-invite'),
          icon: 'trash-alt',
          hasPermission: invitesRemoveEnabled(this.permissionIsEnabled),
          fnAction: invite => this.$emit('openModal', invite, 'CANCEL_INVITE')
        },
        {
          type: 'router-link',
          field: 'id',
          hasPermission: invitesGetEnabled(this.permissionIsEnabled),
          showButton: true,
          name: 'invitesDetail',
          icon: 'arrow-to-right',
          params: {
            id: 'id'
          }
        }
      ]
    },
    emptyList () {
      return !this.isLoading && this.pagination?.total_items === 0
    }
  }
}
</script>
